import React from 'react';
import { IconButton } from '@mui/material';
import {
  Schedule as ScheduleIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import SidebarPanelHeader from '../SidebarPanelHeader';

interface SchedulingPanelHeaderProps {
  onClose: () => void;
}

const SchedulingPanelHeader: React.FC<SchedulingPanelHeaderProps> = ({
  onClose
}) => (
  <SidebarPanelHeader
    icon={<ScheduleIcon />}
    title="Scheduling"
    infoTooltip="Create recurring schedules: enrich selected cells, import from your CRM, or export to your CRM."
    titleVariant="custom"
    sx={{ mb: 0 }}
    actionButtons={[
      <IconButton
        key="close"
        size="small"
        onClick={onClose}
        aria-label="Close page"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    ]}
  />
);

export default SchedulingPanelHeader;
